import React, { useState, useEffect, useRef } from "react";

// Material-UI
import Skeleton from "@material-ui/lab/Skeleton";
import groupBy from "lodash/groupBy";
import IconButton from "@material-ui/core/IconButton";
import VolumeDownIcon from "@material-ui/icons/VolumeDown";
import Divider from "@material-ui/core/Divider";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";

// components
// import { firestore, useData, Divider, Gap } from "../../components";

// Styles
import useStyles from "./styles/ListAlamat";
// import { currency, convertDate, sumQty } from "../../utils";
import { useData } from "../../../components/firebase/DataProvider";
import { date } from "../../../utils/dateTime";
import { firestore } from "../../../components/firebase/FirebaseProvider";
import { useHistory } from "react-router-dom";
import DetailDialog from "../TransaksiList/DetailDialog";
import InfiniteScroll from "react-infinite-scroll-component";
import Button from "@material-ui/core/Button";

const PopUp = ({ open, handleClose, data }) => {
  const history = useHistory();

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Typography variant="h6">{data.title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">{data.message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          variant="contained"
          color="secondary"
          size="small"
          fullWidth
        >
          Close
        </Button>
        <Button
          onClick={() => history.push("/")}
          variant="contained"
          color="primary"
          size="small"
          fullWidth
        >
          Belanja
        </Button>
      </DialogActions>
    </Dialog>
  );
};

function Toko() {
  const classes = useStyles();

  const [data, setData] = useState([]);
  const [loadingMore, setLoadingMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const lastVisible = useRef();

  const { profilRef } = useData();

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setData([]);
      try {
        const userLevelNotifRef = profilRef.collection("notifications");
        const query = await userLevelNotifRef
          .orderBy("created_at", "desc")
          .limit(10)
          .get();
        if (!query.empty) {
          const newData = query.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          });
          setData((notifLama) => [...notifLama, ...newData]);

          lastVisible.current = query.docs[query.docs.length - 1];
        }
      } catch (e) {
        console.log(e.message);
      }
      setLoading(false);
    }
    fetchData();
  }, [profilRef]);

  const loadMoreProducts = async () => {
    if (lastVisible.current && loadingMore) {
      setLoadingMore(true);
      try {
        const userLevelNotifRef = profilRef.collection("notifications");
        const query = await userLevelNotifRef
          .orderBy("created_at", "desc")
          .startAfter(lastVisible.current)
          .limit(10)
          .get();
        if (!query.empty) {
          const newData = query.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          });

          setData((notifLama) => [...notifLama, ...newData]);

          lastVisible.current = query.docs[query.docs.length - 1];
        } else {
          lastVisible.current = null;
          setLoadingMore(false);
        }
      } catch (e) {}
    }
  };

  const [dialog, setDialog] = useState({
    open: false,
    orderId: {},
  });

  const [popUp, setPopUp] = useState({
    open: false,
    datas: {},
  });

  console.log("popUp => ", popUp.datas);

  const handleClick = (item) => async () => {
    console.log("item", item);
    switch (item?.data?.target_type) {
      case "kategori3":
        const categoriesCol = firestore.collection("categories");
        const filter = await categoriesCol.doc(item?.data?.target_id).get();
        history.push(
          `/kategori/kategori3/${filter?.data().nama}/${item?.data?.target_id}`
        );
        break;
      case "brand":
        const brandCol = firestore.collection("brand");
        const hasil = await brandCol.doc(item?.data?.target_id).get();
        history.push(
          `/kategori/brand/${hasil?.data().nama}/${item?.data?.target_id}`
        );
        break;
      case "produk":
        // console.log(item?.data?.target_id);
        const productsCol = firestore.collection("products");
        const query = await productsCol.doc(item?.data?.target_id).get();
        history.push(`/produk/${query?.data().nama}/${item?.data?.target_id}`);
        // console.log(query?.data().nama);
        break;
      case "webview":
        window.open(`${item?.data?.target_id}`);
        break;
      case "paid-order":
      case "order-diterima":
        setDialog({
          open: true,
          orderId: item?.data?.target_id,
        });
        // window.open();
        // navigation.navigate("TransaksiDetail", { id: item.target_id });
        break;
      case "komisi":
        history.push("/transaksi/komisisaya");
        // navigation.navigate("KomisiSaya");
        break;
      case "jaringan-saya":
        // navigation.navigate("JaringanSaya");
        history.push("//transaksi/jaringansaya");
        break;
      case "pencairan":
        history.push("/transaksi/pencairansaya");
        // navigation.navigate("PencairanSaya");
        break;
      case "inpoin":
        history.push("/tokoramecoin/riwayat");
        break;
      case "popup":
        setPopUp({ datas: item, open: true });
        break;
      default:
        break;
    }
  };

  if (loading) {
    return (
      <div className={classes.contentWrapper}>
        <Skeleton variant="rect" />
      </div>
    );
  }

  const groupDataByDate = groupBy(data, (item) => {
    return date(item.created_at?.toDate?.());
  });

  const sections = Object.entries(groupDataByDate).map(([key, value]) => {
    return {
      title: key,
      data: value,
    };
  });

  return (
    <>
      <InfiniteScroll
        dataLength={data.length}
        style={{ overflow: "hidden", marginBottom: "55px" }}
        next={loadMoreProducts}
        hasMore={loadingMore}
        loader={
          <Typography
            color="primary"
            style={{ textAlign: "center", marginBottom: "20px" }}
          >
            <b>Memuat</b>
          </Typography>
        }
        endMessage={
          <p style={{ textAlign: "center" }}>
            <b>Yay! Kamu Sudah Melihat Semua</b>
          </p>
        }
      >
        {sections.map((item) => (
          <div className={classes.contentWrapper}>
            <div className={classes.head}>
              {/* <div
                style={{
                  backgroundColor: "#DCDCDC",
                  borderRadius: "7px",
                  marginBottom: 15,
                  marginTop: -10,
                }}
              > */}
                <Typography className={classes.title}>{item.title}</Typography>
              {/* </div> */}
            </div>
            {item.data.map((value) => (
              <>
                {/* <Divider style={{ marginLeft: -10, marginRight: -10 }} /> */}
                <div className={classes.body} onClick={handleClick(value)}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <IconButton
                      size="small"
                      style={{ backgroundColor: "#5675D3" }}
                    >
                      <VolumeDownIcon style={{ color: "white" }} />
                    </IconButton>
                    <div style={{ width: "100%" }}>
                      <span className={classes.titleBody}>{value.title}</span>
                      <p className={classes.bodyTitle}>{value.message}</p>
                    </div>
                  </div>
                </div>
                <Divider style={{ marginLeft: -10, marginRight: -10 }} />
              </>
            ))}
          </div>
        ))}
        <PopUp
          open={popUp.open}
          data={popUp.datas}
          handleClose={() => {
            setPopUp({
              open: false,
              datas: {},
            });
          }}
        />
        <DetailDialog
          open={dialog.open}
          orderId={dialog.orderId}
          handleClose={() => {
            setDialog({
              open: false,
              orderId: {},
            });
          }}
        />
      </InfiniteScroll>
    </>
  );
}

export default Toko;
